import { GrapevineCommentEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineCommentEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineCommentEventsApi(configuration),
    [configuration]
  );
};
